<template>
  <v-card flat color="grey lighten-4">
    <v-card-title class="title sarabun primary--text">{{
      $t('password_requirement')
    }}</v-card-title>
    <v-list dense class="transparent">
      <v-list-tile v-for="item in result" :key="item.id">
        <v-list-tile-action>
          <v-icon v-if="item.isValid" color="success">check</v-icon>
          <v-icon v-else color="error">close</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    isValid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules: {
        length: {
          text: this.$t('password_requirement_length'),
          validator: () => this.value.length >= 8 && this.value.length <= 52
        },
        case: {
          text: this.$t('password_requirement_case'),
          validator: () => /[a-z]/.test(this.value) && /[A-Z]/.test(this.value)
        },
        digit: {
          text: this.$t('password_requirement_digit'),
          validator: () => /\d/.test(this.value)
        },
        specialCharacter: {
          text: this.$t('password_requirement_special_character'),
          validator: () => /[!@#$%^&*]/.test(this.value)
        }
      }
    }
  },
  computed: {
    result() {
      return Object.entries(this.rules).map(([key, { text, validator }]) => ({
        id: key,
        text,
        isValid: validator()
      }))
    }
  },
  watch: {
    result: {
      immediate: true,
      handler(value) {
        this.$emit(
          'update:isValid',
          value.every(({ isValid }) => isValid)
        )
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/PasswordValidation.vue